<template>
	<div class="chat-button">
		<button @click="$emit('click', $event)" :style="style">
			<slot>发送</slot>
		</button>
	</div>
</template>

<script>
	export default {
		name: 'chat-button',
		props: {
			color: {
				type: String,
				default: '#3D7C6D'
			}
		},
		computed: {
			style() {
				if (['white', 'WHITE', '#fff', '#FFF', '#ffffff', '#FFFFFF'].includes(this.color)) {
					return `color: #000000;background-color: ${this.color};`;
				}
				return `color: #FFFFFF;background-color: ${this.color};`;
			}
		}
	}
</script>

<style scoped lang="less">
	.chat-button, .chat-button button{
		width: 100%;
		height: 100%;
	}
	.chat-button{
        button{
        	display: flex;
        	align-items: center;
        	justify-content: center;
        	border: none;
        	outline: none;
        	font-size: 13px;
        	cursor: pointer;
        	border-radius: 3px;
        	transition: all 0.5s ease-in-out;
            &::after{
                border: none;
                outline: none;
            }
            &:hover, &:active{
                opacity: 0.8;
            }
        }
    }
</style>